import { Component, OnInit } from '@angular/core';
import { DepartmentService } from 'src/app/services/jrni/department.service';
import { AlertService } from 'src/app/_alert';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatastoreService } from 'src/app/services/datastore.service';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import * as _ from "lodash";
import { MemberService } from 'src/app/services/jrni/member.service';
import { interval } from 'rxjs';

@Component({
  selector: 'app-departments',
  templateUrl: './departments.component.html',
  styleUrls: ['./departments.component.scss']
})
export class DepartmentsComponent implements OnInit {

  childrenDepartments: [];
  pageTitle: string;
  faChevronLeft = faChevronLeft;
  faChevronRight = faChevronRight;
  guidanceMsg: string;
  member: any;
  childRows: any;
  subscription: any;

  constructor(
    private departmentService: DepartmentService,
    private datastoreService: DatastoreService,
    protected alertService: AlertService,
    private router: Router,
    private memberService: MemberService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {
    this.scrollToTop();
    this.spinner.show();
    this.memberService.getMember().then(member => {
      console.log(member)
      this.member = member
      this.getDepartments();

    });
  }

  routerGoBack() {
    this.router.navigate(['/access']);
  }

  restartJourney() {
    this.router.navigate(['/access']);
  }

  async getDepartments() {

    let parentDepartment = this.datastoreService.parentDepartment 
    console.log(parentDepartment)
    if (parentDepartment) {
      this.pageTitle = parentDepartment.extra.location_page_title;
      this.guidanceMsg = parentDepartment.extra.location_page_guidance_text;
    } else{
      this.restartJourney()
    }

    this.datastoreService.extra = parentDepartment.extra;
    let departments = await this.departmentService.getChildDepartments(parentDepartment);
    let sortedDepartments = [];
    sortedDepartments = _.orderBy(departments, ['name', 'asc']) as [];
    this.spinner.hide();

    //@ts-ignore
    this.childrenDepartments = sortedDepartments;
    this.childRows = []
    const chunkSize = 3;
    for (let i = 0; i < sortedDepartments.length; i += chunkSize) {
      const chunk = sortedDepartments.slice(i, i + chunkSize);
      this.childRows.push(chunk)
    }
    // while(true){

    // }
    const source = interval(100);
    this.subscription = source.subscribe(val => {
      let count = 0
      let all = this.childrenDepartments.length
      let maxHeight = 0
      let childRowsMaxHeights = []
      for (let i = 0; i < this.childRows.length; i++) {
        let row = this.childRows[i]
        childRowsMaxHeights.push(0)
        for (let locations of row) {
          const el = document.getElementById(locations.id)
          if (el) {
            count++
              if (maxHeight < el.offsetHeight) {
              childRowsMaxHeights[i] = el.offsetHeight
            }
          }
        }
      }
      if (count >= all) {
        for (let i = 0; i < this.childRows.length; i++) {
          let row = this.childRows[i]
          for (let locations of row) {
            const el = document.getElementById(locations.id)
            el.style.height = `${childRowsMaxHeights[i]}px`
          }
        }
        this.subscription.unsubscribe();
      }
    });
  }

  
  ngOnDestroy() {
    if(this.subscription){
      this.subscription.unsubscribe();
    }
  }

  selectDepartment(department) {
    this.departmentService.set(department);
    this.datastoreService.selectedDepartment = department;
    this.departmentService.setLocation(department);
    // If the department has the setting required login then navigate to login else to services page
    // if (department.hasOwnProperty('extra') && department.extra.hasOwnProperty('login_required')) {
    //   if (department.extra.login_required.toLowerCase() === 'yes') {
    //     this.router.navigate(['/access']);
    //   } else {
    //     if (department.extra.service_or_location_first.toLowerCase() === 'service') {
    //       this.router.navigate(['/services']);
    //     }
    //   }
    // }
  }

  // scroll to the top of the page
  scrollToTop() {
    window.scroll(0, 0);
  }
}
